import { sum } from 'lodash';
import * as React from 'react';
import { useEffect } from 'react';
import { PieChart } from '../../../../components/muiLegacy/Charts/PieChart';
import AnalysisChartLoading from '../../AnalysisChartLoading';
import { DomainTypeGq } from '../../../../graphql/projects/models/DomainTypeGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';
import { ChartProps } from '../../AnalysisList';
import { rankIntervals, rankSegmentNames } from '../../IntervalsAndColorsLogic';
import DataTimedOut, { didQueryTimeout } from '../DataTimedOut';
import NotEnoughData from '../NotEnoughData';

export interface RanksByKeywordsChartProps extends ChartProps { }

const RanksByKeywordsChart: React.FC<RanksByKeywordsChartProps> = ({
  project,
  analysisFilterState,
  setAnalysisFilterState,
  palette,
}) => {
  // Adjust shown filters
  useEffect(
    () =>
      setAnalysisFilterState((prev) => ({
        ...prev,
        shownFields: {
          showTagGroupId: true,
          showTagId: true,
        },
      })),
    []
  );

  // Retrieve data
  const { result, query } = projectsApiService.queries.analysis.getRankIntervals({
    projectId: project.id,
    projectDomainId: project.domains?.find((x) => x.type === DomainTypeGq.PROJECT)?.id,
    rankIntervals: rankIntervals,
    tagGroupId: analysisFilterState?.tagGroupId,
    tagId: analysisFilterState?.tagId,
  });

  const data = result?.intervalAnalyses
    .map((x, index) => ({
      id: rankSegmentNames[index],
      value: x.keywordCount / sum(result?.intervalAnalyses.map((x) => x.keywordCount)),
    }));

  // Render
  if (didQueryTimeout(query)) {
    return <DataTimedOut />;
  }

  if (query?.loading) {
    return <AnalysisChartLoading />;
  }

  if (!data?.some((x) => x.value > 0)) {
    return <NotEnoughData />;
  }

  return <PieChart data={data} valueForm={' >-.0%'} colors="stoplight" palette={palette} />;
};

export default RanksByKeywordsChart;
